import { useCallback, useMemo } from 'react';

/**
 * Hook to convert old ionRangeSlider settings format to new RangeSlider props
 * and handle callbacks
 */
export default function useRangeSlider(settings) {
  const handleFinish = useCallback(
    (values) => {
      if (settings?.onFinish) {
        // Convert to format expected by onFinish callback
        // ionRangeSlider passes { from, to } for double, { from } for single
        const data = {
          from: values.from,
          to: values.to ?? values.from,
        };
        settings.onFinish(data);
      }
    },
    [settings],
  );

  return useMemo(() => {
    if (!settings) return null;

    // Map old config to new component props - ensure numeric values are numbers
    const props = {
      min: Number(settings.min),
      max: Number(settings.max),
      step: Number(settings.step ?? 1),
      type: settings.type ?? 'double',
      showGrid: settings.grid ?? false,
      gridNum: Number(settings.grid_num ?? 9),
      id: settings.id,
      disabled: settings.disabled ?? false,
      onFinish: handleFinish,
    };

    // Set initial values based on type - ensure they're numbers
    if (settings.type === 'single') {
      props.value = settings.from !== undefined ? Number(settings.from) : undefined;
    } else {
      props.from = settings.from !== undefined ? Number(settings.from) : undefined;
      props.to = settings.to !== undefined ? Number(settings.to) : undefined;
    }

    return props;
  }, [settings, handleFinish]);
}
